/* Common formatting utils. */
var castAsInt = function (value) {
    var parsedValue = parseInt("".concat(value), 10);
    if (isNaN(parsedValue)) {
        return null;
    }
    return parsedValue;
};
var formatPhone = function (phone) {
    if (!phone) {
        return '';
    }
    phone = phone.replace(/\D/g, '');
    if (phone.length) {
        phone = phone.match(new RegExp('.{1,4}$|.{1,3}', 'g')).join('-');
    }
    return phone;
};
var formatPhoneWithoutDash = function (phone) {
    return phone.replace(/-/g, '');
};
var titleCase = function (value) {
    return value[0].toUpperCase() + value.slice(1).toLowerCase();
};
var camelCaseToSnakeCase = function (str) {
    return str.replace(/[A-Z]/g, function (letter) { return "_".concat(letter.toLowerCase()); });
};
var isObject = function (value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
};
var isArray = function (value) {
    return Array.isArray(value);
};
var convertKeysToSnakeCase = function (obj) {
    if (isArray(obj)) {
        return obj.map(function (item) { return convertKeysToSnakeCase(item); });
    }
    if (!isObject(obj)) {
        return obj;
    }
    return Object.keys(obj).reduce(function (acc, key) {
        var newKey = camelCaseToSnakeCase(key);
        var value = obj[key];
        acc[newKey] = convertKeysToSnakeCase(value);
        return acc;
    }, {});
};
var formatArrayCommaString = function (values, conjunction) {
    if (conjunction === void 0) { conjunction = 'and'; }
    if (!values.length) {
        return null;
    }
    if (values.length === 1) {
        return values[0];
    }
    if (values.length === 2) {
        return "".concat(values[0], " ").concat(conjunction, " ").concat(values[1]);
    }
    var lastIndex = values.length - 1;
    return "".concat(values.slice(0, lastIndex).join(', '), " ").concat(conjunction, " ").concat(values[lastIndex]);
};
var parseFirstName = function (name) {
    return name.trim().split(' ')[0];
};
var parseLastName = function (name) {
    var names = name.trim().split(' ');
    if (names.length > 1) {
        return names[names.length - 1];
    }
    return '';
};
/* Casts numbers (integers and floats with .5 decimal) as words or
  returns the original value if other float, negative, or greater than 20 */
var castNumberAsWord = function (value) {
    if (value === 0.5) {
        return 'half a';
    }
    var integerWords = [
        'zero',
        'one',
        'two',
        'three',
        'four',
        'five',
        'six',
        'seven',
        'eight',
        'nine',
        'ten',
        'eleven',
        'twelve',
        'thirteen',
        'fourteen',
        'fifteen',
        'sixteen',
        'seventeen',
        'eighteen',
        'nineteen',
        'twenty',
    ];
    if (value % 1 === 0) {
        return integerWords[value] || value;
    }
    if (value % 1 === 0.5) {
        return "".concat(integerWords[Math.floor(value)], " and a half");
    }
};
var USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});
/**
 * Returns a display-ready string of dollars and cents.
 * @remark Do not use for input or storage! Display only.
 * @param {number} value
 * @return {string}
 */
var formatDollarsText = function (value) {
    return USDollar.format(value);
};
/**
 * Returns a display-ready string of dollars and cents.
 * @remark Do not use for input or storage! Display only.
 * @param {number} value
 * @return {string}
 */
var formatCentsAsDollarsText = function (value) {
    return formatDollarsText(value / 100);
};
/**
 * Converts dollars to an integer of cents.
 * @param {string|number} value
 * @return {number}
 */
var formatDollarsAsCents = function (value) {
    return Math.round(parseFloat(value.toString()) * 100);
};
var capitalizeFirstLetterOfString = function (str) {
    if (!str || !str.length) {
        return '';
    }
    return str[0].toUpperCase() + str.substring(1);
};
/**
 * Returns the plural form of the word if count is greater than 1.
 * @param {string} word
 * @param {number} count
 * @param {string} pluralForm (optional) - if there is a non-standard plural form, eg. 'people' or 'taxes'
 */
var pluralize = function (word, count, pluralForm) {
    if (count === 1) {
        return word;
    }
    return pluralForm !== null && pluralForm !== void 0 ? pluralForm : "".concat(word, "s");
};
export { camelCaseToSnakeCase, castAsInt, castNumberAsWord, capitalizeFirstLetterOfString, convertKeysToSnakeCase, formatArrayCommaString, formatCentsAsDollarsText, formatDollarsAsCents, formatDollarsText, formatPhone, formatPhoneWithoutDash, parseFirstName, parseLastName, pluralize, titleCase, };
